// extracted by mini-css-extract-plugin
module.exports = {"priceSection":"i4fra5","prices":"_2Z_Jcc"};